const IMAGE_SIZES = new Set(['thumbnail', 'medium', 'full'])
const ABSOLUTE_URL_PATTERN = /^https?:\/\//

const withAssetsUrl = (path, size = 'thumbnail', oldPath = 'product-images', config) => {
  if (!path) {
    console.warn(`path is empty or missing using withAssetsUrl`)
    return
  }

  if (ABSOLUTE_URL_PATTERN.test(path)) {
    return path
  }

  if (!config) {
    console.error(`config is missing when using withAssetsUrl`)
    return
  }

  if (!IMAGE_SIZES.has(size)) {
    console.error(`unsupported image size for ${size}, only support: ${[...IMAGE_SIZES].toString()}`)
    return
  }

  if (path && (path.indexOf('im__') > -1 || path.indexOf('imagekit__') > -1)) {
    return config.imagekit[size] + path
  }

  return `${config.api.replace('/api', '')}/uploads/${oldPath}/${path}`
}

export {
  withAssetsUrl
}
